module.exports = __webpack_public_path__ + "img/expenditureItemIcon3.513b6be8.png";